import { lazy } from "react"
import { BASE_ROLES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"

const RolesComponent = lazy(async () => await import("@/pages/dashboard/control/roles"))
const RolesFormComponent = lazy(async () => await import("@/pages/dashboard/control/roles/form.tsx"))

export const controlRolesRoutes: CustomRoute = {
  path: "roles",
  handle: {
    label: "Роли",
    i18Key: "roles",
    allowedPermissions: ["role_view"],
    disallowedRoles: [BASE_ROLES.REPUBLIC_INSPECTOR!]
  },
  children: [
    {
      index: true,
      Component: RolesComponent
    },
    {
      path: "create",
      handle: { label: "Добавить новый", i18Key: "create", hideTabs: true },
      Component: RolesFormComponent
    },
    {
      path: "edit/:roleId",
      handle: { label: "Редактировать", i18Key: "edit", hideTabs: true },
      Component: RolesFormComponent
    }
  ]
}
